module.exports = __webpack_public_path__ + "static/golden-stripe-299a4dbc4bd5bbe6dfe928babf767056.png";